import { COLOR_PALETTE } from 'constants/ui';

import { TELEPHONY_WIDGET_HEIGHT, TELEPHONY_WIDGET_WIDTH } from './TelephonyWidget.constants';

export const phoneButtonStyles = {
  minWidth: 'auto',
  padding: '8px',
  position: 'relative',
  marginLeft: 'auto',
  color: ({ palette }) => palette.common.white,

  '&:hover': {
    backgroundColor: ({ palette }) => palette.primary.dark,
  },

  '&[data-is-active="true"]': {
    backgroundColor: ({ palette }) => `${palette.primary.dark} !important`,
  },

  '@keyframes reconnecting-pulse': {
    '0%, 100%': { opacity: 1 },
    '50%': { opacity: 0.4 },
  },

  '&[data-is-reconnecting="true"]': {
    animation: 'reconnecting-pulse 1.5s ease-in-out infinite',
  },

  '@keyframes incoming-ring': {
    '0%, 100%': { boxShadow: '0 0 0 0 rgba(76, 175, 80, 0.7)' },
    '50%': { boxShadow: '0 0 0 8px rgba(76, 175, 80, 0)' },
  },

  '&[data-is-incoming="true"]': {
    animation: 'incoming-ring 1s ease-in-out infinite',
    backgroundColor: 'rgba(76, 175, 80, 0.3) !important',
  },
};

export const availabilityDotStyles = {
  position: 'absolute',
  bottom: 6,
  right: 6,
  width: 8,
  height: 8,
  borderRadius: '50%',
  border: '1.5px solid',
  borderColor: ({ palette }) => palette.primary.main,
};

export const popoverPaperStyles = {
  width: `${TELEPHONY_WIDGET_WIDTH}px`,
  height: `${TELEPHONY_WIDGET_HEIGHT}px`,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  borderRadius: '12px',
};

export const headerStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '16px 16px 12px',
  borderBottom: ({ palette }) => `1px solid ${palette.border.default}`,
  flexShrink: 0,
};

export const headerLeftStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
};

export const statusRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  cursor: 'pointer',
  padding: '4px 8px',
  borderRadius: '6px',
  '&:hover': {
    backgroundColor: ({ palette }) => palette.background.disabled,
  },
  '&:focus-visible': {
    outline: `2px solid ${COLOR_PALETTE.BLUE[5]}`,
    outlineOffset: 2,
  },
};

export const statusMenuItemStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '8px 16px',
  minWidth: 180,
};

export const statusMenuDotStyles = {
  width: 8,
  height: 8,
  borderRadius: '50%',
  flexShrink: 0,
};

export const statusDotStyles = {
  width: 8,
  height: 8,
  borderRadius: '50%',
  flexShrink: 0,
};

export const contentWrapperStyles = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  minHeight: 0,
};

export const contentAreaStyles = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'auto',
  backgroundColor: ({ palette }) => palette.background.secondary,
  padding: '24px',
  gap: '12px',
};

export const placeholderIconStyles = {
  color: ({ palette }) => palette.text.disabled,
};

export const placeholderTextStyles = {
  textAlign: 'center',
  color: ({ palette }) => palette.text.placeholder,
};

export const headerActionsStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
};

export const settingsButtonStyles = {
  padding: '4px',
  color: ({ palette }) => palette.text.placeholder,
  '&:hover': {
    color: ({ palette }) => palette.text.dark,
  },
};

export const closeButtonStyles = {
  padding: '4px',
  color: ({ palette }) => palette.text.secondary,
};

export const reconnectingLabelStyles = {
  color: COLOR_PALETTE.ORANGE[6],
  fontSize: 11,
  lineHeight: 1,
  '@keyframes pulse': {
    '0%, 100%': { opacity: 1 },
    '50%': { opacity: 0.5 },
  },
  animation: 'pulse 1.5s ease-in-out infinite',
};

const connectionBannerStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '6px 16px',
  flexShrink: 0,
  fontSize: 12,
  lineHeight: 1.4,
};

export const connectionBannerErrorStyles = {
  ...connectionBannerStyles,
  backgroundColor: COLOR_PALETTE.RED[1],
  color: COLOR_PALETTE.RED[7],
};

export const connectionBannerWarningStyles = {
  ...connectionBannerStyles,
  backgroundColor: COLOR_PALETTE.ORANGE[1],
  color: COLOR_PALETTE.ORANGE[7],
  '@keyframes pulse': {
    '0%, 100%': { opacity: 1 },
    '50%': { opacity: 0.5 },
  },
  animation: 'pulse 1.5s ease-in-out infinite',
};
